export default __webpack_public_path__ + "static/media/pantry1-afterD-768w.8084e3d5.avif";